import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCookies } from 'react-cookie';
import { useNewApp, useNewAppWithCookie, useFingerPrintApp } from './newApp.logic';
import { Loading, NewViewer } from './newViewer';
import FingerPrintProvider from '~/components/FingerPrintProvider';
const FingerPrintApp = () => {
    const [cookies] = useCookies(['OneroomAdminAPIToken']);
    const { isLoading, token, error, verified, verifying, data } = useNewApp(cookies.OneroomAdminAPIToken, eventDataProps.data.id, eventDataProps.data.main_camera_id);
    const { fingerPrintContext, openFormModal } = useFingerPrintApp(data, verified, token);
    if (isLoading || verifying) {
        return _jsx(Loading, {});
    }
    if (error) {
        return _jsxs("div", { children: ["An error occured: ", error.message] });
    }
    return (_jsx(FingerPrintProvider, { value: fingerPrintContext, children: _jsx(NewViewer, { openFormModal: openFormModal, nameOnly: false }) }));
};
const FingerPrintAppWithCookie = ({ data }) => {
    const { token, verified, verifying } = useNewAppWithCookie(eventDataProps.data.id, eventDataProps.data.main_camera_id, data);
    const { fingerPrintContext, openFormModal } = useFingerPrintApp(data, verified, token);
    if (verifying) {
        return _jsx(Loading, {});
    }
    return (_jsx(FingerPrintProvider, { value: fingerPrintContext, children: _jsx(NewViewer, { openFormModal: openFormModal, nameOnly: false }) }));
};
const App = () => {
    const [cookies] = useCookies(['OneroomFingerPrint']);
    if (cookies.OneroomFingerPrint) {
        return _jsx(FingerPrintAppWithCookie, { data: cookies.OneroomFingerPrint });
    }
    else {
        return _jsx(FingerPrintApp, {});
    }
};
export default App;
